import React from 'react';
const rows = [['Planning tomorrow’s activity at night', 'Open the volume, pick the activity, lead it'], ['Half the room asleep, the rest done in five minutes', 'One activity at DO, HELP and FEEL in the same session'], ['Residents in their rooms with nothing planned', 'FEEL versions and 10-minute 1:1 visits (Volume 6)'], ['Nothing in hand when nursing asks', 'A participation log you fill in after every group'], ['The same bingo on repeat', '90 activities across six volumes']];
export function CostOfInaction() {
  return <section className="w-full bg-plum-deep" data-id="element-65" data-mp="38vsfebos1ezv">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-66" data-mp="3dolg8oh4k36o">
        <h2 className="text-center font-display font-bold text-white text-3xl sm:text-4xl" data-id="element-67" data-mp="3dqeryi6lhdlj">
          What another year of improvising{' '}
          <span className="italic text-gold" data-id="element-68" data-mp="3nn1av1fd1ukx">costs you</span>
        </h2>
        <div className="mt-8 overflow-hidden rounded-3xl border border-plum-line" data-id="element-69" data-mp="3nkon27mx8pzy">
          <div className="grid grid-cols-2 bg-plum-mid text-center text-[12px] font-semibold uppercase tracking-wider" data-id="element-70" data-mp="3sji0y164ej0n">
            <div className="border-r border-plum-line px-3 py-2.5 text-coral-soft" data-id="element-71" data-mp="39hd52nzk1mm4">
              Without the ladder
            </div>
            <div className="px-3 py-2.5 text-gold" data-id="element-72" data-mp="34jbms59ydrbp">
              With Memory Care Activity Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-plum-line text-[13px] sm:text-sm" data-id="element-73" data-mp="11a759y8vcaz">
              <div className="border-r border-plum-line px-3.5 py-3.5 text-white/65 line-through decoration-coral/70" data-id="element-74" data-mp="3s8ebty6x2mg8">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-75" data-mp="3jg2owmb0hh50">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}